/**
 * i18n minimale: dizionario IT/EN, funzione t() con interpolazione {var}.
 * Lingua selezionata salvata in localStorage solo con consenso storage.
 */

import { isStorageConsentAccepted } from './privacy';

type Lang = 'it' | 'en';

type Dict = Record<string, string>;

const dictionaries: Record<Lang, Dict> = {
  it: {
    'app.title': 'Gamez',
    'app.tagline': 'Quiz e indovinelli',
    'lobby.choose': 'Scegli un gioco',
    'setup.title': 'Configura partita',
    'setup.mode.single': 'Singolo giocatore',
    'setup.mode.multi-players': 'Più giocatori',
    'setup.mode.teams': 'Squadre',
    'setup.players': 'Giocatori',
    'setup.teams': 'Squadre',
    'setup.add_player': 'Aggiungi giocatore',
    'setup.add_team': 'Aggiungi squadra',
    'setup.player_name': 'Nome giocatore',
    'setup.team_name': 'Nome squadra',
    'setup.turn_order': 'Ordine dei turni',
    'setup.turn_order.hint': 'Trascina o usa le frecce per riordinare.',
    'setup.daily': 'Sfida giornaliera (stesso enigma per tutti)',
    'setup.start': 'Inizia partita',
    'setup.error.min_players': 'Servono almeno {n} giocatori.',
    'setup.error.empty_name': 'Inserisci un nome valido.',
    'turn.handoff.title': 'Tocca a {name}',
    'turn.handoff.subtitle': 'Passa il dispositivo e poi tocca per continuare.',
    'turn.handoff.continue': 'Sono io, continua',
    'turn.guess.placeholder': 'Inserisci la tua risposta',
    'turn.guess.submit': 'Invia',
    'turn.attempt': 'Tentativi: {n}',
    'win.title': 'Indovinato!',
    'win.summary': 'Trovato in {n} tentativi',
    'win.back': 'Torna alla lobby',
    'win.replay': 'Gioca ancora',
    'common.resume': 'Riprendi partita',
    'common.new_game': 'Nuova partita',
    'common.cancel': 'Annulla',
    'common.confirm': 'Conferma',
    'common.remove': 'Rimuovi',
    'common.back': 'Indietro',
    'common.delete': 'Elimina',
    'common.surrender': 'Arrenditi',
    'common.surrender.confirm': 'Vuoi arrenderti? Verrà rivelata la soluzione.',
    'common.surrendered.title': 'Soluzione rivelata',
    'common.target_was': 'La soluzione era: {name}',
    'common.you': 'Tu',
    'lobby.delete_session': 'Elimina partita',
    'lobby.delete_session.confirm': 'Eliminare questa partita in corso?',
    'lobby.storage_ephemeral': 'Salvataggi solo finché la scheda resta aperta',
    'privacy.manage': 'Privacy e salvataggi',
    'privacy.title': 'Cookie e dati salvati',
    'privacy.body': 'Gamez non usa cookie di tracciamento né servizi pubblicitari. Con il consenso salva nel browser lingua, partite in corso, statistiche locali e cache tecnica per caricare più velocemente. Se rifiuti, eliminiamo salvataggi e cache: puoi giocare, ma le nuove partite restano solo nella scheda aperta.',
    'privacy.current.accepted': 'Stato attuale: salvataggio persistente attivo.',
    'privacy.current.rejected': 'Stato attuale: salvataggio persistente disattivato.',
    'privacy.accept': 'Accetta',
    'privacy.reject': 'Rifiuta',
    'privacy.close': 'Chiudi',
    'globe.name': 'Globe Guess',
    'globe.description': 'Indovina il paese misterioso usando distanza, direzione e globo 3D.',
    'globe.distance': '{km} km dal misterioso',
    'globe.bearing.N': 'a Nord',
    'globe.bearing.NE': 'a Nord-Est',
    'globe.bearing.E': 'a Est',
    'globe.bearing.SE': 'a Sud-Est',
    'globe.bearing.S': 'a Sud',
    'globe.bearing.SW': 'a Sud-Ovest',
    'globe.bearing.W': 'a Ovest',
    'globe.bearing.NW': 'a Nord-Ovest',
    'globe.unknown_country': 'Paese non riconosciuto.',
    'globe.duplicate_country': 'Hai già inserito questo paese. Prova con un altro.',
    'globe.surrender': 'Arrenditi',
    'globe.surrender.confirm': 'Sei sicuro? Verrà rivelato il paese misterioso.',
    'globe.surrendered.title': 'Ti sei arreso',
    'globe.target_was': 'Il paese misterioso era: {name}',
    'globe.new_game': 'Nuova partita',
    'globe.loading': 'Carico il globo…',
    'globe.borders_target': '🔴 Confina con il paese misterioso!',
    'animals.name': 'Indovina l\u2019animale',
    'animals.description': 'Trova l\u2019animale misterioso in una lista curata di specie riconoscibili.',
    'animals.unknown_guess': 'Animale non riconosciuto. Prova con un nome comune.',
    'animals.duplicate_guess': 'Hai già provato questo animale.',
    'animals.surrender': 'Arrenditi',
    'animals.surrender.confirm': 'Vuoi arrenderti? Verrà rivelato l\u2019animale misterioso.',
    'animals.surrendered.title': 'Animale rivelato',
    'animals.target_was': 'L\u2019animale misterioso era: {name}',
    'animals.new_game': 'Nuova partita',
    'animals.hint.request': 'Richiedi un indizio',
    'animals.hint.locked_one': 'Indizio disponibile dopo un altro tentativo',
    'animals.hint.locked': 'Indizio disponibile tra {n} tentativi',
    'animals.hint.none_left': 'Non ci sono altri indizi.',
    'animals.hint.klass': 'Classe: {value}',
    'animals.hint.habitat': 'Habitat: {value}',
    'animals.hint.diet': 'Dieta: {value}',
    'animals.hint.size': 'Taglia: {value}',
    'animals.hint.continents': 'Diffusione: {value}',
    'animals.hint.legs': 'Zampe/arti: {value}',
    'animals.hint.clue': 'Particolarità: {value}',
    'animals.score': '{score}/{max} attributi in comune',
    'animals.klass.mammal': 'Mammifero',
    'animals.klass.bird': 'Uccello',
    'animals.klass.reptile': 'Rettile',
    'animals.klass.fish': 'Pesce',
    'animals.klass.amphibian': 'Anfibio',
    'animals.klass.insect': 'Insetto',
    'animals.klass.arachnid': 'Aracnide',
    'animals.klass.mollusk': 'Mollusco',
    'animals.klass.crustacean': 'Crostaceo',
    'animals.habitat.forest': 'Foresta',
    'animals.habitat.savanna': 'Savana/prateria',
    'animals.habitat.desert': 'Deserto',
    'animals.habitat.ocean': 'Oceano',
    'animals.habitat.mountain': 'Montagna',
    'animals.habitat.arctic': 'Regioni polari',
    'animals.habitat.freshwater': 'Acqua dolce',
    'animals.habitat.domestic': 'Domestico',
    'animals.diet.carnivore': 'Carnivoro',
    'animals.diet.herbivore': 'Erbivoro',
    'animals.diet.omnivore': 'Onnivoro',
    'animals.size.small': 'Piccola',
    'animals.size.medium': 'Media',
    'animals.size.large': 'Grande',
    'animals.range.africa': 'Africa',
    'animals.range.asia': 'Asia',
    'animals.range.europe': 'Europa',
    'animals.range.north_america': 'Nord America',
    'animals.range.south_america': 'Sud America',
    'animals.range.oceania': 'Oceania',
    'animals.range.antarctica': 'Antartide',
    'animals.range.arctic': 'Artico',
    'animals.range.ocean': 'Oceani',
    'animals.range.worldwide': 'Tutto il mondo',
    'animals.range.domestic': 'Ambienti domestici',
    'animals.legs_value': '{value} zampe/arti',
  },
  en: {
    'app.title': 'Gamez',
    'app.tagline': 'Quizzes & guessing games',
    'lobby.choose': 'Pick a game',
    'setup.title': 'Set up game',
    'setup.mode.single': 'Single player',
    'setup.mode.multi-players': 'Multiple players',
    'setup.mode.teams': 'Teams',
    'setup.players': 'Players',
    'setup.teams': 'Teams',
    'setup.add_player': 'Add player',
    'setup.add_team': 'Add team',
    'setup.player_name': 'Player name',
    'setup.team_name': 'Team name',
    'setup.turn_order': 'Turn order',
    'setup.turn_order.hint': 'Use arrows to reorder.',
    'setup.daily': 'Daily challenge (same puzzle for everyone)',
    'setup.start': 'Start game',
    'setup.error.min_players': 'At least {n} players required.',
    'setup.error.empty_name': 'Please enter a valid name.',
    'turn.handoff.title': "{name}'s turn",
    'turn.handoff.subtitle': 'Hand over the device, then tap to continue.',
    'turn.handoff.continue': "It's me, continue",
    'turn.guess.placeholder': 'Type your answer',
    'turn.guess.submit': 'Submit',
    'turn.attempt': 'Attempts: {n}',
    'win.title': 'You got it!',
    'win.summary': 'Found in {n} attempts',
    'win.back': 'Back to lobby',
    'win.replay': 'Play again',
    'common.resume': 'Resume game',
    'common.new_game': 'New game',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.remove': 'Remove',
    'common.back': 'Back',
    'common.delete': 'Delete',
    'common.surrender': 'Give up',
    'common.surrender.confirm': 'Give up? The answer will be revealed.',
    'common.surrendered.title': 'Answer revealed',
    'common.target_was': 'The answer was: {name}',
    'common.you': 'You',
    'lobby.delete_session': 'Delete game',
    'lobby.delete_session.confirm': 'Delete this game in progress?',
    'lobby.storage_ephemeral': 'Saves last only while this tab stays open',
    'privacy.manage': 'Privacy and saves',
    'privacy.title': 'Cookies and saved data',
    'privacy.body': 'Gamez does not use tracking cookies or advertising services. With consent it stores language, games in progress, local stats and technical cache in your browser so the app loads faster. If you reject, saved games and cache are cleared: you can play, but new games stay only in the open tab.',
    'privacy.current.accepted': 'Current status: persistent saving enabled.',
    'privacy.current.rejected': 'Current status: persistent saving disabled.',
    'privacy.accept': 'Accept',
    'privacy.reject': 'Reject',
    'privacy.close': 'Close',
    'globe.name': 'Globe Guess',
    'globe.description': 'Guess the mystery country using distance, direction and the 3D globe.',
    'globe.borders_target': '🔴 Borders the mystery country!',
    'globe.distance': '{km} km from the mystery',
    'globe.bearing.N': 'to the North',
    'globe.bearing.NE': 'to the North-East',
    'globe.bearing.E': 'to the East',
    'globe.bearing.SE': 'to the South-East',
    'globe.bearing.S': 'to the South',
    'globe.bearing.SW': 'to the South-West',
    'globe.bearing.W': 'to the West',
    'globe.bearing.NW': 'to the North-West',
    'globe.unknown_country': 'Unknown country.',    'globe.duplicate_country': 'You already guessed that country. Try another.',
    'globe.surrender': 'Give up',
    'globe.surrender.confirm': 'Are you sure? The mystery country will be revealed.',
    'globe.surrendered.title': 'You gave up',
    'globe.target_was': 'The mystery country was: {name}',
    'globe.new_game': 'New game',    'globe.loading': 'Loading the globe\u2026',
    'animals.name': 'Guess the animal',
    'animals.description': 'Find the mystery animal from a curated list of recognizable animals.',
    'animals.unknown_guess': 'Animal not recognized. Try again.',
    'animals.duplicate_guess': 'You already guessed this animal.',
    'animals.surrender': 'Give up',
    'animals.surrender.confirm': 'Give up? The mystery animal will be revealed.',
    'animals.surrendered.title': 'Animal revealed',
    'animals.target_was': 'The mystery animal was: {name}',
    'animals.new_game': 'New game',
    'animals.hint.request': 'Request a hint',
    'animals.hint.locked_one': 'Hint unlocks after one more guess',
    'animals.hint.locked': 'Hint unlocks in {n} guesses',
    'animals.hint.none_left': 'No more hints available.',
    'animals.hint.klass': 'Class: {value}',
    'animals.hint.habitat': 'Habitat: {value}',
    'animals.hint.diet': 'Diet: {value}',
    'animals.hint.size': 'Size: {value}',
    'animals.hint.continents': 'Range: {value}',
    'animals.hint.legs': 'Legs: {value}',
    'animals.hint.clue': 'Trait: {value}',
    'animals.score': '{score}/{max} attributes in common',
    'animals.klass.mammal': 'Mammal',
    'animals.klass.bird': 'Bird',
    'animals.klass.reptile': 'Reptile',
    'animals.klass.fish': 'Fish',
    'animals.klass.amphibian': 'Amphibian',
    'animals.klass.insect': 'Insect',
    'animals.klass.arachnid': 'Arachnid',
    'animals.klass.mollusk': 'Mollusk',
    'animals.klass.crustacean': 'Crustacean',
    'animals.habitat.forest': 'Forest',
    'animals.habitat.savanna': 'Savanna',
    'animals.habitat.desert': 'Desert',
    'animals.habitat.ocean': 'Ocean',
    'animals.habitat.mountain': 'Mountain',
    'animals.habitat.arctic': 'Arctic',
    'animals.habitat.freshwater': 'Freshwater',
    'animals.habitat.domestic': 'Domestic',
    'animals.diet.carnivore': 'Carnivore',
    'animals.diet.herbivore': 'Herbivore',
    'animals.diet.omnivore': 'Omnivore',
    'animals.size.small': 'Small',
    'animals.size.medium': 'Medium',
    'animals.size.large': 'Large',
    'animals.range.africa': 'Africa',
    'animals.range.asia': 'Asia',
    'animals.range.europe': 'Europe',
    'animals.range.north_america': 'North America',
    'animals.range.south_america': 'South America',
    'animals.range.oceania': 'Oceania',
    'animals.range.antarctica': 'Antarctica',
    'animals.range.arctic': 'Arctic',
    'animals.range.ocean': 'Oceans',
    'animals.range.worldwide': 'Worldwide',
    'animals.range.domestic': 'Domestic settings',
    'animals.legs_value': '{value} legs/limbs',
    'common.unknown_guess': 'Not recognized. Try again.',
    'common.duplicate_guess': 'Already guessed. Try another.',
  },
};

const STORAGE_KEY = 'gamez.lang';
const SESSION_STORAGE_KEY = 'gamez.lang.session';

function detectLang(): Lang {
  try {
    const saved = isStorageConsentAccepted() ? localStorage.getItem(STORAGE_KEY) : sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (saved === 'it' || saved === 'en') return saved;
  } catch { /* Browser privacy settings can disable either storage API. */ }
  return typeof navigator === 'undefined' || navigator.language.toLowerCase().startsWith('it') ? 'it' : 'en';
}

let currentLang: Lang = detectLang();

export function setLang(lang: Lang): void {
  currentLang = lang;
  try {
    if (isStorageConsentAccepted()) {
      localStorage.setItem(STORAGE_KEY, lang);
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    } else {
      sessionStorage.setItem(SESSION_STORAGE_KEY, lang);
    }
  } catch { /* The in-memory language choice still applies. */ }
  if (typeof document !== 'undefined') document.documentElement.lang = lang;
}

export function getLang(): Lang {
  return currentLang;
}

export function t(key: string, vars: Record<string, string | number> = {}): string {
  const dict = dictionaries[currentLang];
  let msg = dict[key] ?? dictionaries.en[key] ?? key;
  for (const [k, v] of Object.entries(vars)) {
    msg = msg.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
  }
  return msg;
}

/** Ritorna true se la chiave esiste nel dizionario corrente o in quello EN di fallback. */
export function has(key: string): boolean {
  return key in dictionaries[currentLang] || key in dictionaries.en;
}
